module.exports = __webpack_public_path__ + "img/lrc.f54d5988.svg";